import React, { useEffect, useRef, useState } from 'react';

const PLATFORMS = [
  {
    name: 'Meta Ads',
    color: '#1877f2',
    bg: '#EEF4FF',
    border: '#BFDBFE',
    glow: 'rgba(24,119,242,0.15)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <path d="M18 2C9.163 2 2 9.163 2 18s7.163 16 16 16 16-7.163 16-16S26.837 2 18 2z" fill="#1877f2"/>
        <path d="M22.5 11h-2.25c-.966 0-1.25.402-1.25 1.25V14h3.5l-.5 3.5H19V28h-3.5V17.5H14V14h1.5v-2.25C15.5 9.13 17.024 8 19.75 8H22.5v3z" fill="#fff"/>
      </svg>
    ),
  },
  {
    name: 'TikTok Ads',
    color: '#010101',
    bg: '#F3F4F6',
    border: '#D1D5DB',
    glow: 'rgba(1,1,1,0.1)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="#010101"/>
        <path d="M24.5 8h-3.5v13.5a3.5 3.5 0 11-3.5-3.5c.2 0 .4.02.6.04V14.5a7 7 0 100 7.5V8z" fill="#fff"/>
        <path d="M26.5 10.5v3.5a7.48 7.48 0 01-3.5-.87v7.37a7 7 0 11-7-7c.24 0 .48.01.71.04v3.54a3.5 3.5 0 10-3.21 3.46V10.5h13z" fill="#f0264e" opacity=".8"/>
      </svg>
    ),
  },
  {
    name: 'Google Ads',
    color: '#4285f4',
    bg: '#EFF6FF',
    border: '#BFDBFE',
    glow: 'rgba(66,133,244,0.15)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <path d="M10 18a8 8 0 1116 0 8 8 0 01-16 0z" fill="none"/>
        <path d="M18 10a8 8 0 000 16v-4a4 4 0 110-8v-4z" fill="#4285f4"/>
        <path d="M26 18a8 8 0 01-8 8v-4a4 4 0 004-4h4z" fill="#34a853"/>
        <path d="M13.17 24.83A8 8 0 0110 18h4a4 4 0 002.83 3.83l-3.66 3z" fill="#fbbc05"/>
        <path d="M18 10a8 8 0 014.83 1.17l-3 3.66A4 4 0 0018 14v-4z" fill="#ea4335"/>
      </svg>
    ),
  },
  {
    name: 'LinkedIn Ads',
    color: '#0a66c2',
    bg: '#EFF6FF',
    border: '#BAE6FD',
    glow: 'rgba(10,102,194,0.15)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="6" fill="#0a66c2"/>
        <path d="M10 14h4v12h-4V14zm2-6a2 2 0 110 4 2 2 0 010-4zM16 14h3.8v1.65h.05c.53-1 1.83-2.05 3.75-2.05 4.01 0 4.75 2.64 4.75 6.07V26h-4v-5.7c0-1.36-.03-3.1-1.89-3.1-1.9 0-2.19 1.48-2.19 3v5.8H16V14z" fill="#fff"/>
      </svg>
    ),
  },
  {
    name: 'Snapchat Ads',
    color: '#8B7500',
    bg: '#FEFCE8',
    border: '#FDE68A',
    glow: 'rgba(255,252,0,0.2)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="#fffc00"/>
        <path d="M18 8c-3.86 0-6.5 2.64-6.5 6.5 0 .5.05 1.03.1 1.5-.4.2-.8.3-1.1.3-.4 0-.7-.2-.7-.5s.2-.5.6-.7c-.1-.1-.2-.3-.2-.5 0-.4.3-.7.7-.7.1 0 .2 0 .3.1-.1-.3-.1-.7-.1-1C11 9.57 14 7 18 7s7 2.57 7 6.5c0 .3 0 .7-.1 1 .1-.1.2-.1.3-.1.4 0 .7.3.7.7 0 .2-.1.4-.2.5.4.2.6.4.6.7s-.3.5-.7.5c-.3 0-.7-.1-1.1-.3.05-.47.1-1 .1-1.5C24.5 10.64 21.86 8 18 8zm5.5 11c-.5 1.5-2.5 2.5-5.5 2.5s-5-1-5.5-2.5c-1 .2-2 .3-2.5.3-.5 0-.5-.5-.2-.7.7-.5 1.2-1 1.4-1.6.3-1 .1-2.3-.2-3.5-.2-.8-.5-1.5-.5-2.5 0-3.3 3.1-5.5 7-5.5s7 2.2 7 5.5c0 1-.3 1.7-.5 2.5-.3 1.2-.5 2.5-.2 3.5.2.6.7 1.1 1.4 1.6.3.2.3.7-.2.7-.5 0-1.5-.1-2.5-.3z" fill="#1a1a1a"/>
      </svg>
    ),
  },
  {
    name: 'Taboola Ads',
    color: '#1862D9',
    bg: '#EFF4FF',
    border: '#BFD4FE',
    glow: 'rgba(24,98,217,0.15)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="#1862D9"/>
        <ellipse cx="12.5" cy="18" rx="4.5" ry="6" fill="#fff"/>
        <ellipse cx="23.5" cy="18" rx="4.5" ry="6" fill="#fff"/>
        <ellipse cx="13.8" cy="18" rx="1.8" ry="2.6" fill="#1862D9"/>
        <ellipse cx="24.8" cy="18" rx="1.8" ry="2.6" fill="#1862D9"/>
      </svg>
    ),
  },
  {
    name: 'Shopify',
    color: '#5a7a1a',
    bg: '#F0FDF4',
    border: '#BBF7D0',
    glow: 'rgba(150,191,72,0.15)',
    status: 'Available',
    icon: (
      <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
        <rect width="36" height="36" rx="8" fill="#96bf48"/>
        <path d="M22.5 9.5s-.2-.1-.5-.1c-.2 0-1.1.2-1.8 1.3-.6.9-.8 2.2-.8 2.2l-3.1.5-.7 11.1 8.4 1.5L26 11.5l-3.5-2zm-2 1.5c-.5.7-.7 1.7-.7 1.7l-1.4.2s.5-1.6 1.4-2.2c.3-.2.6-.3.7-.3v.6zm-5.5 9.5l-.3-3.2 2.3-.4.4 3.2-2.4.4zm3.5-4.5l-2.3.4-.3-3.1 2.3-.4.3 3.1z" fill="#fff"/>
      </svg>
    ),
  },
];

const Integrations = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="integrations" ref={ref} style={{ background: '#fff', padding: '96px 24px', overflow: 'hidden' }}>
      <style>{`
        @keyframes intFadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .int-card {
          transition: transform 0.2s ease, box-shadow 0.2s ease !important;
        }
        .int-card:hover {
          transform: translateY(-6px) !important;
        }
      `}</style>

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: 64 }}>
          <div className="mono-label" style={{ color: '#737373', marginBottom: 22 }}>
            <span style={{ color: '#4F46E5' }}>/</span> Integrations
          </div>
          <h2 style={{ fontSize: 'clamp(28px,4vw,46px)', fontWeight: 700, color: '#111', letterSpacing: '-0.035em', marginBottom: 14, lineHeight: 1.1, maxWidth: 640 }}>
            Connect every platform{' '}
            <em className="serif-accent">you already use.</em>
          </h2>
          <p style={{ fontSize: 15, color: '#737373', maxWidth: 440, lineHeight: 1.65 }}>
            One-click OAuth connection for all major ad networks. No API keys, no developer setup.
          </p>
        </div>

        {/* Platform grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 40 }}>
          {PLATFORMS.map((p, i) => (
            <div
              key={i}
              className="int-card"
              style={{
                background: '#F6F7FB',
                border: '1px solid #E5E6EF',
                borderRadius: 14,
                padding: '26px 16px',
                textAlign: 'center',
                cursor: 'default',
                opacity: visible ? 1 : 0,
                animation: visible ? `intFadeUp 0.5s ease ${i * 80}ms both` : 'none',
              }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#CDCFE0'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#E5E6EF'; }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                {p.icon}
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#111', marginBottom: 7 }}>{p.name}</div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 999, background: 'rgba(129,140,248,0.18)' }}>
                <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#4F46E5' }} />
                <span style={{ fontSize: 10, fontWeight: 700, color: '#4338CA' }}>{p.status}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom info bar */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
          padding: '20px 32px',
          background: '#F6F7FB',
          border: '1px solid #E5E6EF',
          borderRadius: 14,
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.8s 0.5s ease',
        }}>
          <div style={{ fontSize: 13, color: '#737373', textAlign: 'center', lineHeight: 1.6 }}>
            All connections secured with{' '}
            <span style={{ color: '#111', fontWeight: 600 }}>OAuth 2.0</span> — we never store your ad account passwords.
            <span style={{ display: 'inline-block', marginLeft: 12, padding: '3px 10px', background: '#fff', border: '1px solid #E5E6EF', borderRadius: 6, fontSize: 11, color: '#525252', fontWeight: 600 }}>
              More integrations coming soon
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Integrations;
